"use strict";
const angular = require("angular");

export class loginComponent {
  /*@ngInject*/
  user = {
    name: "",
    email: "",
    password: "",
  };
  errors = {
    other: undefined,
  };
  submitted = false;

  /*@ngInject*/
  constructor(Auth, $state, LanguageService) {
    "ngInject";
    this.Auth = Auth;
    this.$state = $state;
    this.ls = LanguageService;
    this.showHomeMsg = +new Date() < +new Date("2025-01-02");
  }

  login(form) {
    this.submitted = true;
    this.errors.other = undefined;
    this.errors.disabled = undefined;
    if (form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password,
      })
        .then(() => {
          // Logged in, redirect to home
          this.$state.go("permission");
        })
        .catch((err) => {
          if (err) {
            if (err.message == "This account is not enabled.") {
              this.errors.disabled = true;
            } else {
              this.errors.other = err.message;
            }
          }
        });
    }
  }
}

export default angular.module("dalApp.login", []).component("login", {
  template: require("./login.html"),
  controller: loginComponent,
}).name;



// WEBPACK FOOTER //
// ./client/app/account/login/login.component.js